<template>
  <div>
    <div style="height: 190px">
      <div class="dashIcon">
        <div>
          <div
            style="
              position: absolute;
              background-color: #a3a3a3;
              margin: 6px 0 0 13px;
            "
          >
            <div style="font-size: 23px">Purchasers</div>
          </div>

          <img
            src="/images/purchasers.png"
            alt="Purchasers"
            width="100%"
            height="100%"
          />
        </div>
      </div>
      <div class="q-pt-md">
        <q-toggle label="Display Archived" v-model="displayArchived"></q-toggle>
      </div>
    </div>
    <q-separator color="black" />

    <div class="row items-center q-py-xs">
      <div class="col q-pl-sm">Name</div>
      <div class="col q-pl-sm">Order</div>
      <div
        class="col-auto"
        :style="`width: ${$q.screen.xs ? '88' : '112'}px`"
      ></div>
    </div>

    <q-separator color="black" />

    <div v-for="purchaser in Purchasers" :key="purchaser.id">
      <div class="row items-center">
        <div class="col q-pl-sm">{{ decoder(purchaser.name) }}</div>
        <div class="col q-pl-sm">
          {{ purchaser.order }}
        </div>
        <div class="col-auto q-pa-sm">
          <q-btn
            unelevated
            icon="edit"
            size="md"
            :padding="$q.screen.xs ? '2px 4px' : '2px 10px'"
            color="grey-3"
            text-color="primary"
            class="q-mr-sm"
            @click="editPurchaser(purchaser)"
          >
          </q-btn>
          <q-btn
            v-if="!purchaser.archived && purchaser.transactions > 0"
            unelevated
            color="grey-3"
            text-color="accent"
            icon="archive"
            size="md"
            :padding="$q.screen.xs ? '2px 4px' : '2px 10px'"
            @click="archivePurchaser(purchaser, true)"
          />
          <q-btn
            v-if="purchaser.archived"
            unelevated
            icon="unarchive"
            size="md"
            color="grey-3"
            text-color="secondary"
            :padding="$q.screen.xs ? '2px 4px' : '2px 10px'"
            @click="archivePurchaser(purchaser, false)"
          />
          <q-btn
            v-if="!purchaser.archived && purchaser.transactions === 0"
            unelevated
            color="grey-3"
            text-color="accent"
            icon="delete"
            size="md"
            :padding="$q.screen.xs ? '2px 4px' : '2px 10px'"
            @click="deletePurchaser(purchaser)"
          />
        </div>
      </div>
      <q-separator />
    </div>

    <!-- Dialog Enter Purchaser -->
    <q-dialog v-model="dialogPurchaserEntry" persistent position="top">
      <q-card style="width: 400px">
        <div class="row items-center q-pa-md">
          <div class="col text-center text-h5">Purchaser</div>
          <div class="col-auto">
            <q-btn icon="close" color="primary" v-close-popup />
          </div>
        </div>
        <q-separator />

        <q-form @submit="onSubmit" class="q-pa-md">
          <q-input
            outlined
            v-model="purchaserObj.name"
            label="Name"
            maxlength="32"
            class="q-mb-md"
            hide-bottom-space
            :rules="[(value) => value !== '' || 'Name cannot be blank']"
          />
          <q-input
            outlined
            v-model="purchaserObj.order"
            label="Order"
            type="number"
            min="0"
            step="1"
            class="q-mb-md"
            hide-bottom-space
            :rules="[(value) => value !== '' || 'Order cannot be blank']"
          />

          <div class="row justify-end">
            <q-btn label="Submit" type="submit" color="primary" />
          </div>
        </q-form>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { decoder, cloneObj, upperCaseFirst } from '@/lib/helpers';
import store from '@/store';
const newPurchaser = () => {
  return {
    id: 0,
    farm_id: store.getters.selectedFarm.id,
    grain_id: null,
    name: '',
    order: 0,
    archived: false,
    transactions: 0,
    storeInfo: {}
  };
};

export default {
  name: 'Settings-Purchasers',
  data() {
    return {
      decoder,
      dialogPurchaserEntry: false,
      displayArchived: false,
      purchaserObj: newPurchaser()
    };
  },
  methods: {
    add() {
      this.purchaserObj = newPurchaser();

      this.dialogPurchaserEntry = true;
    },
    archivePurchaser(purchaser, value) {
      const purchaserCopy = cloneObj(purchaser);
      purchaserCopy.archived = value;

      purchaserCopy.storeInfo = {
        farmId: store.state.farm.id
      };

      this.$q
        .dialog({
          title: 'Archive Purchaser',
          message: `Are you sure you want to ${
            value ? 'archive' : 'unarchive'
          } this purchaser?`,
          ok: {
            color: 'accent',
            label: value ? 'Archive' : 'Unarchive',
            icon: value ? 'archive' : 'unarchive'
          },
          cancel: {
            color: 'grey-2',
            textColor: 'primary',
            label: 'cancel',
            icon: 'close'
          },
          focus: 'none',
          persistent: true
        })
        .onOk(() => {
          this.archivePurchaserConfirmed(purchaserCopy);
        });
    },
    archivePurchaserConfirmed(purchaser) {
      store
        .dispatch('updatePurchaser', {
          purchaser
        })
        .then((results) => {
          this.$finishResult.handleResultsAsync(results);
        });
    },
    deletePurchaser(purchaser) {
      purchaser.storeInfo = {
        farmId: store.state.farm.id
      };

      this.$q
        .dialog({
          title: 'Delete purchaser',
          message: `Are you sure you want to delete this purchaser?`,
          ok: {
            color: 'accent',
            label: 'Delete',
            icon: 'delete'
          },
          cancel: {
            color: 'grey-2',
            textColor: 'primary',
            label: 'cancel',
            icon: 'close'
          },
          focus: 'none',
          persistent: true
        })
        .onOk(() => {
          this.deletePurchaserConfirmed(purchaser);
        });
    },
    deletePurchaserConfirmed(purchaser) {
      store
        .dispatch('deletePurchaser', {
          purchaser
        })
        .then((results) => {
          this.$finishResult.handleResultsAsync(results);
        });
    },
    editPurchaser(purchaser) {
      this.purchaserObj = cloneObj(purchaser);
      this.purchaserObj.name = decoder(this.purchaserObj.name);
      this.dialogPurchaserEntry = true;
    },
    onSubmit() {
      let dispatch;
      if (this.purchaserObj.id === 0) {
        dispatch = 'createPurchaser';
      } else {
        dispatch = 'updatePurchaser';
      }

      this.purchaserObj.name = upperCaseFirst(this.purchaserObj.name);

      this.purchaserObj.storeInfo = {
        farmId: store.state.farm.id
      };

      store
        .dispatch(dispatch, {
          purchaser: this.purchaserObj
        })
        .then((results) => {
          this.$finishResult.handleResultsAsync(results);
        });

      this.dialogPurchaserEntry = false;
    }
  },
  computed: {
    Purchasers() {
      let purchasers = cloneObj(this.$store.state.farm.purchasers);
      if (!this.displayArchived) {
        purchasers = purchasers.filter((element) => !element.archived);
      }

      return purchasers.sort((a, b) => {
        a.name.localeCompare(b.name);
      });
    }
  }
};
</script>

<style scoped></style>
